/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MerchantSearchMerchant,
    MerchantSearchMerchantFromJSON,
    MerchantSearchMerchantFromJSONTyped,
    MerchantSearchMerchantToJSON,
} from './MerchantSearchMerchant';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';

/**
 * 
 * @export
 * @interface MerchantResponse
 */
export interface MerchantResponse {
    /**
     * 
     * @type {Array<MerchantSearchMerchant>}
     * @memberof MerchantResponse
     */
    results: Array<MerchantSearchMerchant>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof MerchantResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof MerchantResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof MerchantResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof MerchantResponse
     */
    hasPreviousPage?: boolean;
}

export function MerchantResponseFromJSON(json: any): MerchantResponse {
    return MerchantResponseFromJSONTyped(json, false);
}

export function MerchantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(MerchantSearchMerchantFromJSON)),
        'listResult': QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function MerchantResponseToJSON(value?: MerchantResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(MerchantSearchMerchantToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

